import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import './LandingPage.css';
import Hero from './Hero';
import Features from './Features';
import Contact from './Contact';
import Footer from './Footer';

const LandingPage = () => {
  const history = useHistory();

  useEffect(() => {
    // Verificar si el usuario ya está logueado
    const userdata = localStorage.getItem('userdata');
    if (userdata) {
      try {
        const userData = JSON.parse(userdata);
        if (userData && userData.access_token) {
          // Redirigir al dashboard si ya está autenticado
          history.push('/inicio');
        }
      } catch (error) {
        console.log('Error parsing userdata:', error);
      }
    }
  }, [history]);

  return (
    <div className="landing-page">
      <Hero />
      <Features />
      <Contact />
      <Footer />
    </div>
  );
};

export default LandingPage;
